<template>
    <div id="app">
        <div class="page-content" role="main">
        <div class="bg-black text-3xl py-6 wwf-title hidden sm:block">
          <div class="max-w-r-max mx-8 xl:mx-auto">
        <a href="https://wwf.org.uk/" class="text-link transition xl:px-24">
        Go to wwf.org.uk
        </a>
        </div>
        </div>
          <div class="max-w-r-max mx-8 xl:px-24 xl:mb-24 xl:mx-auto">
            <router-view/>
          </div>
    </div>
    </div>
</template>

<script>
import './assets/css/main.scss';
</script>
